import React, { useEffect, useMemo, memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { CommandBar } from '@fluentui/react/lib/CommandBar'
import { getSyncProjects } from '../../actions/projects'
import { createLoadingSelector } from '../../reducers/api'
import { createAllProjectSelector } from '../../reducers/projects'
import AccessControl from '../AccessControl'
import { sortArrayByStringKey } from '../../helpers/string'
import style from './style.module.css'

const CommandBarComp = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const isFetching = useSelector(createLoadingSelector(['PROJECTS_SYNC_GET']))
  const projects = useSelector(createAllProjectSelector)

  useEffect(() => {
    dispatch(getSyncProjects())
  }, [dispatch])

  const projectSubItems = useMemo(() => {
    if (isFetching) return [{ key: '1', name: 'Loading...' }]
    if (!projects.length) return [{ key: '1', name: 'No project' }]

    return projects.map(project => ({
      className: project.isRigMovedOut && style.grey,
      key: project.id,
      text: project.name,
      onClick: () => history.push(`/project/${project.id}`),
    })).sort(sortArrayByStringKey('text'))
  }, [isFetching, projects, history])

  const menuItems = location.pathname.includes('/admin') ?
    [{
      text: 'general setting',
      key: '/general',
      iconProps: {
        iconName: 'Settings'
      },
      onClick: () => history.push('/admin/general'),
    },
    {
      text: 'roles & responsibilities',
      key: '/roles',
      iconProps: {
        iconName: 'People'
      },
      onClick: () => history.push('/admin/users/roles')
    }] : [{
      text: 'live',
      key: 'live',
      // iconProps: {
      //   iconName: 'GlobalNavButton'
      // },
      subMenuProps: {
        items: projectSubItems
      }
    }]
  const farItems = location.pathname.includes('/admin') ?
    [{
      text: 'switch to live',
      key: '/project',
      onClick: () => history.push('/'),
    }] : [{
      text: 'switch to admin',
      key: '/admin',
      onClick: () => history.push('/admin/general'),
    }]

  return (
    <AccessControl
      allowedPermissions={['admin']}
      renderNoAccess={() => (
        <CommandBar
          styles={{ root: { height: '45px' } }}
          items={menuItems}
        />
      )}
    >
      <CommandBar
        styles={{ root: { height: '45px' } }}
        items={menuItems}
        farItems={farItems}
      />
    </AccessControl>
  )
}

export default memo(CommandBarComp)
